import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function MechanismSection() {
  return <section className="py-16 md:py-24 px-4 bg-brand-brown text-white" data-id="element-100">
      <div className="max-w-2xl mx-auto" data-id="element-101">
        <FadeIn data-id="element-102">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-brand-cream" data-id="element-103">
            El Micro-Ritual de los 600 Segundos
          </h2>
          <p className="text-lg mb-6 leading-relaxed text-brand-cream/90" data-id="element-104">
            No es psicología compleja, es logística emocional. Se basa en el{' '}
            <strong data-id="element-105">"Efecto Puente"</strong>: un protocolo táctico que elimina
            la presión de "actuar" para el niño.
          </p>
          <p className="text-lg leading-relaxed text-brand-cream/90" data-id="element-106">
            Al aplicar pasos de <em data-id="element-107">Silencio, Servicio y Señal</em>, permites
            que su sistema nervioso se relaje y la conexión surja de forma
            natural, sin forzarla.
          </p>
        </FadeIn>
      </div>
    </section>;
}